require('@popperjs/core')
require('./bootstrap');
require('@fortawesome/fontawesome-free/js/all');
require('select2');

import $ from 'jquery';
window.$ = window.jQuery = $;

import Swal from 'sweetalert2/dist/sweetalert2.js';
import toastr from 'toastr/toastr.js'
import tableDatatable from 'datatables/media/js/jquery.dataTables.min'

toastr.options.closeButton = true;
toastr.options.newestOnTop = false;

window.Swal = Swal;
window.toastr = toastr;
window.tableDatatable = tableDatatable;
